import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../../index';
import { ToastContainer } from 'react-toastify';
import { CreditCardPassThroughConfig } from './credit-card-pass-through-config';
import { AdminContextProvider } from '../../../../context/admin-context';

export function initCreditCardPassThroughConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('credit-card-pass-through-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        root.render(
          v2Component(
            <AdminContextProvider>
              <ToastContainer />
              <CreditCardPassThroughConfig />
            </AdminContextProvider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
